import { formatMonthShort } from "./date-format-utils";

/** Chart palette built on the admin theme (ews-primary #21596c, ews-secondary #3ba1a1). */
export const CHART_COLORS = {
  primary: "#21596c",
  secondary: "#3ba1a1",
  green: "#16a34a",
  amber: "#f59e0b",
  sky: "#0ea5e9",
  rose: "#e11d48",
  violet: "#7c3aed",
  slate: "#64748b",
};

/** "2026-09" as a short localized month, e.g. "Sep 2026" / "sept. 2026". */
export const monthLabel = (month: string, locale?: string) =>
  locale === undefined
    ? formatMonthShort(month)
    : formatMonthShort(month, locale);
